import httpClient from '../lib/http-client'

const reportApi = {
  findAll () {
    return httpClient.get('/report-data')
  },
  findById (id) {
    return httpClient.get(`/report-data/${id}`)
  },
  dashboardFindAll (page = 1, target = null, keyword = null, group = null) {
    let url = '/report-data/dashboard?page=' + page
    if (target) {
      url += '&target=' + target
    }
    if (keyword) {
      url += '&keyword=' + keyword
    }
    if (group) {
      url += '&group=' + group
    }
    return httpClient.get(url)
  },
  findByOptions (model) {
    return httpClient.post(`/report-data/by-options`, model)
  },
  updateTitle (id, title) {
    return httpClient.put(`/report-data/${id}`, { title })
  },
  remove (id) {
    return httpClient.delete(`/report-data/${id}`)
  }
}

export default reportApi



// WEBPACK FOOTER //
// ./src/api/report-data.js